import { useBuyerActivityStatus } from "lib/hooks/api/buyer_activity/useBuyerActivityStatus";
import { BuyerActivityObjectType, BuyerActivityStatus } from "lib/types/graphQLEnums";
import { CoreNotice } from "./types";
import { getNoticeBuyerData } from "./utils";

type BuyerActivityCompletionProps = {
  status?: BuyerActivityStatus | null;
  notices: CoreNotice[];
  objectId: string;
  objectType: BuyerActivityObjectType;
};

/**
 * While a buyer activity report is pending, listens for it to finish and writes the result into
 * the lead or bid query cache, so anything rendering that object picks up the finished report.
 */
export function useBuyerActivityCompletion({
  status,
  notices,
  objectId,
  objectType,
}: BuyerActivityCompletionProps) {
  const noticeBuyerData = getNoticeBuyerData(
    notices.map((notice) => ({
      procurementStageId: notice.procurementStage.id,
      publishDate: notice.publishDate ?? null,
      buyers: (notice.buyers ?? []).map((buyer) => ({
        guid: buyer.guid,
        name: buyer.name ?? "",
        createdAt: buyer.createdAt ?? null,
      })),
    })),
  );

  useBuyerActivityStatus({
    noticeIds: noticeBuyerData?.notices.map((notice) => notice.procurementStageId) || [],
    buyerId: noticeBuyerData?.buyer.guid || "",
    objectId,
    objectType,
    enabled: status === BuyerActivityStatus.Pending && !!noticeBuyerData,
  });
}
